import { default as Container } from './SoldSubscriptionsSection.container';
import { default as Component } from './SoldSubscriptionsSection';
export default Container(Component);
